export const PLAN_PRICING = {
  monthly: { price: 197 },
  quarterly: { price: 400, installment: 150, installments: 3 },
  yearly: { price: 800, installment: 93, installments: 12 },
} as const;

export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  BRL: 'R$',
};
